// M04 Einladung annehmen.
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { ApiError, api } from '../api/client';
import { Field } from '../components/ui';
import { AuthLayout } from './AuthLayout';

export function InvitePage() {
  const { token = '' } = useParams();
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/auth/invitations/accept', { token, displayName: name, password });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? Object.values(err.problem.errors ?? {}).flat()[0] ?? err.message : String(err));
    }
  };
  return (
    <AuthLayout>
      <h1>{t('invite.title')}</h1>
      {done ? (
        <div className="col" style={{ marginTop: 20 }}>
          <div className="hint">{t('invite.done')}</div>
          <Link className="btn primary" to="/login">{t('login.submit')}</Link>
        </div>
      ) : (
        <>
          <div className="muted">{t('invite.sub')}</div>
          <form onSubmit={submit}>
            <Field label={t('invite.name')}><input required value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" /></Field>
            <Field label={t('invite.password')} hint={t('invite.passwordHint')}>
              <input type="password" required minLength={12} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
            </Field>
            <div className="error" role="alert">{error}</div>
            <button className="btn primary" disabled={!name || password.length < 12}>{t('invite.submit')}</button>
          </form>
        </>
      )}
    </AuthLayout>
  );
}
